import { Box, Grid, Typography } from '@material-ui/core';
import * as React from 'react';
import { LegendIntervalsGq } from '../../../pages/AnalysisPage/IntervalsAndColorsLogic';

export interface ChartLegendProps {
  title?: string;
  intervals: LegendIntervalsGq[];
  circle?: boolean;
}

const ChartLegend: React.FC<ChartLegendProps> = ({ title, intervals, circle }) => {
  return (
    <Box my={1}>
      <Grid container justifyContent={'center'}>
        {title && (
          <Grid item xs={12}>
            <Box py={1}>
              <Typography variant={'caption'}>{title}</Typography>
            </Box>
          </Grid>
        )}
        {intervals.map((interval, index) => (
          <Grid item key={index}>
            <Box pr={2} py={0.5} display={'flex'} flexDirection={'row'} alignItems={'center'}>
              <Box
                width={'18px'}
                height={'18px'}
                borderRadius={circle ? '50%' : '3px'}
                border={'1px solid'}
                borderColor={'#fff'}
                bgcolor={interval.bgcolor}
              ></Box>
              <Box pl={1.5}>{interval.name}</Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ChartLegend;
